export default __webpack_public_path__ + "static/media/beer.b509a452.jpg";